import {
    Button,
    Flex,
    Table,
    TableBody,
    TableCell,
    TableHead,
    TableHeaderCell,
    TableRow,
    Text,
    TextInput,
    Title,
} from '@tremor/react'
import { useEffect, useRef, useState } from 'react'
import {
    ArrowPathIcon,
    ClipboardDocumentIcon,
    TrashIcon,
} from '@heroicons/react/24/outline'
import clipboardCopy from 'clipboard-copy'
import { useApiV1S3Create, useApiV1S3List } from '../../api/api.gen'
import Modal from '../../components/Layout/modal'
import { toErrorString, toErrorText } from '../../utilities/error'
import Confirm from '../../components/Layout/confirm'
import Spinner from '../../components/Spinner'

export default function S3Page() {
    const [deleteID, setDeleteID] = useState<number>()
    const [showModal, setShowModal] = useState(false)
    const [showResultModal, setShowResultModal] = useState(false)
    const [name, setName] = useState('')

    const {
        response: endpointResponse,
        isLoading: endpointLoading,
        error: endpointError,
        sendNow: endpointRefresh,
    } = useApiV1S3List()

    const {
        isLoading: enableLoading,
        isExecuted: enableExecuted,
        error: enableError,
        sendNow: enable,
    } = useApiV1S3Create({}, false)

    // const {
    //     response: createResponse,
    //     isLoading: createLoading,
    //     isExecuted: createExecuted,
    //     sendNowWithParams: create,
    //     error: createError,
    // } = useApiV1S3KeysGenerateCreate({}, {}, false)

    // const {
    //     isLoading: keysLoading,
    //     isExecuted: keysExecuted,
    //     response: keys,
    //     sendNow: refresh,
    // } = useApiV1S3KeysList()

    useEffect(() => {
        if (enableExecuted && !enableLoading) {
            if (toErrorString(enableError).length === 0) {
                endpointRefresh()
            }
        }
    }, [enableLoading])

    // useEffect(() => {
    //     if (
    //         createExecuted &&
    //         !createLoading &&
    //         toErrorString(createError).length === 0
    //     ) {
    //         setShowResultModal(true)
    //         setShowModal(false)
    //         refresh()
    //     }
    // }, [createLoading])

    if (endpointLoading) {
        return <Spinner />
    }

    if (endpointError) {
        return (
            <Text className="text-red-600">{toErrorString(endpointError)}</Text>
        )
    }

    if ((endpointResponse?.api || '').length === 0) {
        return (
            <Flex
                className="p-4 w-auto min-w-[1000px] max-w-fit h-full mt-4 rounded-md"
                flexDirection="col"
                justifyContent="center"
                alignItems="center"
            >
                <Title className="mb-4 text-center">
                    In order to use WatadTech object storage, first you need to
                    enable object storage for your account.
                    <br /> There&apos;s no charge for enabling object storage
                </Title>
                <Text className="text-red-500">
                    {toErrorString(enableError)}
                </Text>
                <Button
                    loading={enableLoading && enableExecuted}
                    disabled={enableLoading && enableExecuted}
                    variant="secondary"
                    color="teal"
                    onClick={enable}
                >
                    Enable Object Storage
                </Button>
            </Flex>
        )
    }

    return (
        <Flex
            className="p-4 bg-gray-50 w-auto min-w-fit max-w-fit mt-4 rounded-md"
            flexDirection="col"
            justifyContent="start"
            alignItems="start"
        >
            <Flex
                flexDirection="row"
                justifyContent="between"
                className="pb-1 border-b"
            >
                <Flex
                    flexDirection="col"
                    justifyContent="start"
                    alignItems="start"
                >
                    <Title className="text-teal-600">Object Storage</Title>
                </Flex>
            </Flex>
            <Flex
                flexDirection="row"
                alignItems="center"
                justifyContent="center"
                className="pt-4"
            >
                <Flex
                    flexDirection="col"
                    justifyContent="start"
                    alignItems="start"
                    className="pr-10"
                >
                    <Text className="text-teal-600 font-medium ml-1 mt-1">
                        Console:{' '}
                        <span className="text-gray-600 font-medium">
                            {endpointResponse?.console}
                        </span>
                    </Text>
                    <Text className="text-teal-600 font-medium ml-1 mt-1">
                        S3 Endpoint:{' '}
                        <span className="text-gray-600 font-medium">
                            {endpointResponse?.api}
                        </span>
                    </Text>
                    <Text className="text-teal-600 font-medium ml-1 mt-1">
                        Console username:{' '}
                        <span className="text-gray-600 font-medium">
                            {endpointResponse?.username}
                        </span>
                    </Text>
                    <Text className="text-teal-600 font-medium ml-1 mt-1">
                        Console password:{' '}
                        <span className="text-gray-600 font-medium">
                            {endpointResponse?.password}
                        </span>
                    </Text>
                </Flex>
                <Flex className="w-fit space-x-2">
                    <a
                        href={endpointResponse?.console}
                        target="_blank"
                        rel="noreferrer"
                    >
                        <Button variant="secondary" color="teal">
                            Open console
                        </Button>
                    </a>
                </Flex>
            </Flex>
        </Flex>
    )
}
